import React from 'react';
import submissionRedIcon from '../../../../../assets/images/submissionRed.png';
import submissionWhiteIcon from '../../../../../assets/images/submissionWhite.png';
import inscriptionRedIcon from '../../../../../assets/images/inscriptionRed.png';
import inscriptionWhiteIcon from '../../../../../assets/images/inscriptionWhite.png';
import studentInscriptionRedIcon from '../../../../../assets/images/studentInscriptionRedIcon.png';
import studentInscriptionWhiteIcon from '../../../../../assets/images/studentInscriptionWhiteIcon.png';
import { Link } from 'react-router-dom';
import { getLang } from '../../../../../environnement';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../../../store/langSlice';

function EventFormItem({
  title,
  icon,
  iconHovered,
  link,
  details
}) {
  return (
    <Link to={link}>
      <div className={`group mx-14 mb-10 sm:mb-16 flex flex-col items-center ${details ? 'sm:h-96' : 'xxs:h-96'} cursor-pointer`}>
        <div className={`rounded-full border border-primary w-40 h-40 ${details ? 'sm:w-60 sm:h-60' : 'xxs:w-60 xxs:h-60'} flex justify-center items-center group-hover:bg-primary`}>
          <img src={icon} alt='itemIcon' className='group-hover:hidden w-24 h-24'/>
          <img src={iconHovered} alt='itemIcon' className='hidden group-hover:inline w-24 h-24'/>
        </div>
        <p className={`font-medium text-primary text-center mt-5 ${details ? 'text-sm sm:text-xl' : 'text-xl'}`}>{title}</p>
      </div>
    </Link>
  );
}

export default function EventForms({
  eventFormDiv,
  details=false
}) {
  const lang = useSelector(langSelector);

  return (
    <div ref={eventFormDiv} className='flex flex-col items-center'>
      <p className={`text-primary mx-10 xxs:mx-0 text-center my-10 ${details ? 'text-sm sm:text-3xl font-bold' : 'text-2xl xxs:text-3xl font-medium'}`}>{getLang(lang).firstWorldCup.participerEvent}</p>
      <div className='flex flex-col justify-center items-center pt-5 pb-10 lg:flex-row w-[90%]'>
        <EventFormItem details={details} icon={submissionRedIcon} iconHovered={submissionWhiteIcon} title={getLang(lang).firstWorldCup.soumission} link='/worldcup-soumission' />
        <span className='text-5xl text-primary font-medium lg:h-60 hidden lg:inline'>...</span>
        <EventFormItem details={details} icon={inscriptionRedIcon} iconHovered={inscriptionWhiteIcon} title={getLang(lang).firstWorldCup.inscriptionNotStudent} link='/worldcup-inscription' />
        <span className='text-5xl text-primary font-medium lg:h-60 hidden lg:inline'>...</span>
        <EventFormItem details={details} icon={studentInscriptionRedIcon} iconHovered={studentInscriptionWhiteIcon} title={getLang(lang).firstWorldCup.inscriptionStudent} link='/worldcup-inscription-student' />
      </div>
    </div>
  );
}
